import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import MainLayout from '@/layouts/MainLayout';
import Home from '@/pages/Home';
import Company from '@/pages/Company';
import Products from '@/pages/Products';
import Origins from '@/pages/Origins';
import Quality from '@/pages/Quality';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Contact from '@/pages/Contact';
import ResumeDemo from '@/pages/ResumeDemo';
import NotFound from '@/pages/NotFound';
import { siteConfig } from '@/config/site.config';
import '@/styles/App.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<MainLayout />}>
                    <Route index element={<Home />} />
                    {/* Additional page templates (§11) — see `siteConfig.pages` for the matching navbar links. */}
                    <Route path="company" element={<Company />} />
                    <Route path="products" element={<Products />} />
                    <Route path="origins" element={<Origins />} />
                    <Route path="quality" element={<Quality />} />
                    <Route path="blog" element={<Blog />} />
                    <Route path="blog/:slug" element={<BlogPost />} />
                    <Route path="contact" element={<Contact />} />
                    {/* Reference implementation of the optional résumé/portfolio product
              variant (§11) — not linked from the default nav, see `ResumeDemo.tsx`. */}
                    <Route path="resume-demo" element={<ResumeDemo />} />
                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
            {/* Both are no-ops off Vercel; toggle via `siteConfig.analytics` to opt out. */}
            {siteConfig.analytics.enabled && <Analytics />}
            {siteConfig.analytics.speedInsights && <SpeedInsights />}
        </Router>
    );
}

export default App;
